import { Injectable } from '@angular/core';
import { LocaleSettings } from 'primeng/datepicker';
import { HttpClient } from '@angular/common/http';
import { Observable, of, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PrimengLocaleLoaderService {
  private localeCache: { [lang: string]: LocaleSettings } = {};

  constructor(private http: HttpClient) {}

  loadLocale(lang: string): Observable<LocaleSettings> {
    if (this.localeCache[lang]) {
      return of(this.localeCache[lang]);
    }

    const localeUrl = `assets/i18n/primeng/primeng_${lang}.json`;

    return this.http.get<LocaleSettings>(localeUrl).pipe(
      tap(localeSettings => {
        this.localeCache[lang] = localeSettings;
      }),
    );
  }
}
